import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import chapter from './chapter';
import courseEntry from './course-entry';
import userInfo from './user-info';
import playground from './playground';

const reducers = combineReducers({
  // 添加reducer
  chapter,
  courseEntry,
  userInfo,
  playground,
});

const composeEnhancers = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;

const middlewares = [ thunkMiddleware ];

if (process.env.NODE_ENV === 'development' && process.env.TARO_ENV !== 'quickapp') {
  // middlewares.push(require('redux-logger').createLogger())
}

const enhancer = composeEnhancers(
  applyMiddleware(...middlewares),
);

export default function configStore () {
  return createStore(reducers, enhancer);
}
